export const OrderSummaryStatus = {
    CREATED: 'CREATED',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PAID: 'PAID',
    PACKED: 'PACKED',
    OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
    DELIVERED: 'DELIVERED',
    DELETED: 'DELETED',
};
//# sourceMappingURL=OrderSummaryStatus.js.map